export const dailyAssistant = {
  seo: {
    title: "Folyamatos AI asszisztens — Bespire",
    description:
      "Napi brief, teendő-kezelés, proaktív javaslatok, heti-havi riport. A Bespire AI asszisztens minden nap veled dolgozik.",
  },
  hero: {
    badge: "Folyamatos AI asszisztens",
    title: "Egy asszisztens, aki minden nap veled dolgozik",
    subtitle:
      "Nem chatbot, amit mindig meg kell szólítanod. A Bespire AI reggel felkészít, napközben szól, ha valamivel foglalkozni kell, este összefoglal — hetente-havonta pedig konkrét javaslatokkal jön.",
    ctaTrial: "Próbáld ki 3 napig ingyen",
    ctaPricing: "Nézd meg az árakat →",
    phoneBrief: {
      title: "Ma reggel",
      time: "2026. jún. 24. · szerda · 07:00",
      greeting: "Jó reggelt, Kata! 5 foglalásod van ma, egy résed délelőtt. Íme, mire figyelj:",
      notifications: [
        { icon: "Calendar", tag: "Nap", text: "5 foglalás, várható bevétel 68 500 Ft" },
        { icon: "Clock", tag: "10:30", text: "Üres slot — 4 pótjelentkező van, küldjek üzenetet?" },
        { icon: "Star", tag: "Új", text: "3 értékelés érkezett, válaszok megírva" },
        { icon: "Bell", tag: "Emlékeztető", text: "2 számla lejárt, mehet emlékeztető?" },
        { icon: "MessageCircle", tag: "Kampány", text: "12 lemorzsolódott ügyfélnek üzenet 7:30-ra ütemezve" },
      ],
      actionApprove: "Mindent jóváhagyok",
      actionOpen: "Áttekintem",
    },
  },
  timeline: {
    title: "Egy nap a Bespire-rel",
    subtitle: "Nem plusz munka — a nap ritmusához igazodik. Reggeltől estig egyetlen íven.",
    events: [
      {
        time: "07:00",
        icon: "Sunrise",
        title: "Napi brief",
        note: "Foglalások, bevétel, 3 prioritás — értesítés a telefonodon.",
      },
      {
        time: "09:30",
        icon: "Calendar",
        title: "Új foglalás",
        note: "Automatikus visszaigazolás, naptár frissítve.",
      },
      {
        time: "10:30",
        icon: "AlertCircle",
        title: "Lemondás → rés-kitöltés",
        note: "4 pótjelentkezőnek üzenet, sorrendben. 1 igen 3 percen belül.",
      },
      {
        time: "13:00",
        icon: "Sparkles",
        title: "Proaktív javaslat",
        note: "Csoportos óra még nincs Instára posztolva — mehet a heti sablon?",
      },
      {
        time: "16:45",
        icon: "Star",
        title: "Új értékelés",
        note: "5 csillag Tóth Andreától — válasz megírva, jóváhagyásra vár.",
      },
      {
        time: "18:00",
        icon: "Moon",
        title: "Napzáró",
        note: "Mit sikerült, mit nem, holnap első 3 dolga — mehetsz haza nyugodtan.",
      },
    ],
  },
  moments: {
    title: "Proaktív pillanatok — amikor a Bespire tényleg számít",
    subtitle: "Nem várja, hogy megkérdezd. Előbb szól, mint hogy problémává válna.",
    items: [
      {
        icon: "Clock",
        situation: "Üres rés a naptárban",
        aiMessage: "13:00-kor 90 perces rés van. Küldjek visszahívó üzenetet a 6 legutóbb lemorzsolódott ügyfélnek?",
        action: "Küldés jóváhagyása",
      },
      {
        icon: "Gift",
        situation: "VIP születésnapja",
        aiMessage: "Kovács Zoltán holnap ünnepel. 5 éve törzsvendég — küldjek egy személyes üzenetet és 20% kedvezményt?",
        action: "Üzenet és ajándék jóváhagyása",
      },
      {
        icon: "AlertTriangle",
        situation: "Negatív értékelés érkezett",
        aiMessage: "3 csillagos értékelés Balázstól — 15 perces várakozás miatt. Empátiás választ + kedvezmény-kupont írtam. Jóváhagyod?",
        action: "Válasz jóváhagyása",
      },
      {
        icon: "Bell",
        situation: "Lejárt számla",
        aiMessage: "Tóth Anna 45 000 Ft-os számlája 7 napja lejárt. Udvarias emlékeztető készen áll. Mehet?",
        action: "Emlékeztető jóváhagyása",
      },
    ],
  },
  reports: {
    title: "Heti és havi riport — nem csak számok, javaslatok",
    subtitle: "A Bespire nem hagyja az elemzést a következő könyvelős találkozóra.",
    weekly: {
      badge: "Heti riport",
      title: "26. hét · vasárnap 18:00",
      kpis: [
        { label: "Bevétel", value: "412 000 Ft", delta: "+8%" },
        { label: "Foglalás", value: "47", delta: "+3" },
        { label: "Új ügyfél", value: "6", delta: "+2" },
        { label: "Értékelés", value: "5 (átlag 4.9)", delta: "+2" },
      ],
      insightTitle: "Fő insight",
      insight: "A péntek este a heti csúcs, de szerda délelőttön 3 hét óta rés van. Csoportos órát ide?",
      action: "Tervezet készítése",
    },
    monthly: {
      badge: "Havi riport",
      title: "Június · trendek és javaslatok",
      kpis: [
        { label: "Havi bevétel", value: "1 847 000 Ft", delta: "+12%" },
        { label: "Aktív ügyfél", value: "84", delta: "+6" },
        { label: "Új ügyfél", value: "18", delta: "+5" },
        { label: "Elszunnyadt", value: "23", delta: "figyelem" },
      ],
      insightTitle: "Fő insight",
      insight: "3 hónapos trend: az esti órák stabilan telnek, a délelőtti csúcs csökkent. Építsünk erre július 1-re egy stratégiát.",
      action: "Havi terv megnyitása",
    },
  },
  chat: {
    title: "Egy reggeli beszélgetés — teljes egészében",
    subtitle: "Így néz ki egy szerdai reggel, ha megnyitod a Bespire chatet.",
    chat: {
      title: "Napi asszisztens",
      online: "Online",
      messages: [
        { role: "assistant" as const, content: "Jó reggelt! ☀️ Íme a mai briefed:", list: [
          "📅 5 foglalás (2 új ügyfél, 3 törzs)",
          "💰 Várható bevétel: 68 500 Ft",
          "⚠️ 10:30-as slot üres — visszahívó javaslat készen",
        ] },
        { role: "user" as const, content: "Mit javasolsz a mai prioritásra?" },
        { role: "assistant" as const, content: "3 dolog, sorrendben:", list: [
          "1. Kovács Anna 3 hete nem foglalt — küldjek üzenetet?",
          "2. A csoportos óra még nincs Instára posztolva",
          "3. 2 számla lejárt — emlékeztető mehet",
        ] },
        { role: "user" as const, content: "Mind a hármat csináld." },
        { role: "assistant" as const, content: "Kész. Frissítek napközben, ha reagálnak. Este 18:00-kor összefoglalom a napot. 📊" },
        { role: "assistant" as const, content: "🔔 Update — 10:32: az egyik pótjelentkező (Kiss Éva) visszaigazolt 10:30-ra. Slot betelt." },
        { role: "user" as const, content: "Szuper. Mit csináljunk 14:00-ig? Van másfél órám." },
        { role: "assistant" as const, content: "Két lehetőség:", list: [
          "📷 Készítek egy 3 posztos Instagram-sorozatot a csoportos órára — 15 perc",
          "☕ Vagy pihenj — a nap üzletileg rendben, minden fut a háttérben",
        ] },
      ],
    },
  },
  quietHours: {
    text: "Hétvégén, szabadságon vagy általad választott csendes órákban automatikusan elhallgat. Te szabod meg, mikor szóljon.",
  },
  crossLinks: {
    title: "A napi asszisztens mindenre rálát",
    subtitle: "Nem külön funkció — ugyanaz az AI, ami az arculatot, a foglalást, a marketinget és az ügyfeleket is kezeli.",
  },
  cta: {
    title: "Ne dolgozz többé egyedül",
    subtitle: "3 nap ingyenes próba, kártya nélkül.",
    primary: "Próbáld ki 3 napig ingyen",
    secondary: "Árak megnézése",
  },
};
